import { isNotEmpty } from './is-empty.util';

export function replaceLineBreaksWithSpaces(value: string): string {
  return value.replace(/[\r\n]+/g, ' ');
}

export function splitTextIntoNonEmptyLines(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(isNotEmpty);
}
